import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Data from "../../../images/industries/healthcare-software/data-driven.png";
import Data1 from "../../../images/industries/healthcare-software/Streamline-And-Automate-Clinical-Tasks.webp";
import Data2 from "../../../images/industries/healthcare-software/Patient-Centric-Care.webp";
import {Link} from 'gatsby';



function Transform(props) {
    const [activeTab, setActiveTab] = useState(1);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }

    return (
        <>
            <div className="tekgriping_section tekrevol_gray_bg  p-100 ">
                <Container className="h-100">
                    <Row className="h-100">
                        <Col xs={12} md={6} lg={5} xl={6} xxl={6} className="my-auto">
                            <div className="example" data-text="Improving">
                                <h2>Improving Care And Saving Lives With Software Development In Healthcare</h2>
                            </div>
                            <p>TekRevol specializes in providing leading-edge software development in the healthcare industry. From ideation to deployment and maintenance, we create innovative and customized healthcare software development services that help healthcare organizations streamline operations and improve patient care. We acquire an in-depth understanding of software engineering services.</p>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={6} xxl={6}>
                            <div className="tekgrip_flex">
                                <div className="tekgrip_title">
                                    <h5>$500
                                        <span>Approx Billion Market by 2025</span></h5>
                                </div>
                                <div className="tekgrip_title">
                                    <h5>18M
                                        <span> Workforce Shortage by 2030</span></h5>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={6} xxl={6}>
                            <h3 onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                <div className="tab_namee">Data-Driven Software Development</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                <div className="tab_namee">Streamline And Automate Clinical Tasks</div>
                            </h3>
                            <h3 onClick={() => {
                                displayTab(3)
                            }} className={`tabs ${activeTab === 3 ? 'active' : ''}`}>
                                <div className="tab_namee">Patient-Centric Care with Remote Patient Monitoring</div>
                            </h3>

                        </Col>

                    </Row>
                </Container>
            </div>
            <div className="p-100">
                <Container className="h-100">
                    <Row className={activeTab === 1 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Data-Driven Software Development</h2>
                                <p>We are a reliable technology partner with outstanding healthcare software developers for complex healthcare software's robust and reliable development, offering full-cycle healthcare software design and development services. Healthcare providers can streamline their medical workflow with data analytics.</p>
                                <Link to="/contact"
                                      className="border_btn" aria-label="TekRevol Contact">Get Cost Estimate</Link>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Data}
                                    effect="blur" alt="Tab_01" className="img-fluid" alt="leading-edge software development"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 2 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Streamline And Automate Clinical Tasks</h2>
                                <p>TekRevol is an experienced medical software company employing technologies like AI and ML to assist healthcare companies in automating clinical tasks like innovative billing and improved patient care with real-time data.</p>
                                <Link to="/contact"
                                      className="border_btn" aria-label="TekRevol Contact">Get Cost Estimate</Link>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Data1}
                                    effect="blur" alt="Tab_01" className="img-fluid"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 3 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Patient-Centric Care with Remote Patient Monitoring</h2>
                                <p>TekRevol is dedicated to transforming healthcare delivery through innovative technology and solutions. Our patient-centric Remote Patient Monitoring (RPM) services offer a seamless approach to healthcare, authorizing patients to receive personalized care. This proactive approach by our healthcare software development company authorizes healthcare providers to offer real-time interventions and personalized care.</p>
                                <Link to="/contact"
                                      className="border_btn" aria-label="TekRevol Contact">Get Cost Estimate</Link>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Data2}
                                    effect="blur" alt="Tab_01" className="img-fluid"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default Transform;